import { render, staticRenderFns } from "./PreviewGbq5.vue?vue&type=template&id=0cc05732&"
import script from "./PreviewGbq5.vue?vue&type=script&lang=js&"
export * from "./PreviewGbq5.vue?vue&type=script&lang=js&"
import style0 from "./PreviewGbq5.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports